export default [
  //账号列表
  {
    path: '/userList',
    name: 'userList',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/userList/index'),
    meta: {
      activeMenu: 'userList', // 可用选中菜单
      keepAlive: true // true 开启。
    }
  },
  // 数据抽取
  {
    path: '/dataExtraction',
    name: 'dataExtraction',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/dataExtraction/index'),
    meta: {
      activeMenu: 'dataExtraction', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //添加账号
  {
    path: '/addUser',
    name: 'addUser',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/userList/addUser/index'),
    meta: {
      activeMenu: 'addUser', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //账号编辑
  {
    path: '/editUserRole',
    name: 'editUserRole',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/userList/editUserRole/index'),
    meta: {
      activeMenu: 'editUserRole', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //组织列表
  {
    path: '/organizationList',
    name: 'organizationList',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/organizationList/index'),
    meta: {
      activeMenu: 'organizationList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //角色列表
  {
    path: '/roleList',
    name: 'roleList',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/roleList/index'),
    meta: {
      activeMenu: 'roleList', // 可用选中菜单
      keepAlive: true // true 开启。
    }
  },
  //新增角色、编辑角色
  {
    path: '/addRole',
    name: 'addRole',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/roleList/addRole/index'),
    meta: {
      activeMenu: 'roleList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //设置角色的权限
  {
    path: '/setRoleAuth',
    name: 'setRoleAuth',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/roleList/setRoleAuth/index'),
    meta: {
      activeMenu: 'roleList', // 可用选中菜单
    }
  },
  //批量设置角色的权限
  {
    path: '/batchAdjustPermissions',
    name: 'batchAdjustPermissions',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/roleList/setRoleAuth/batchAdjustPermissions'),
    meta: {
      activeMenu: 'batchAdjustPermissions', // 可用选中菜单
    }
  },

  /*  事务所权限 */
  {
    path: '/jurisdiction',
    name: 'jurisdiction',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/roleList/jurisdiction/index'),
    meta: {
      activeMenu: 'roleList', // 可用选中菜单
    }
  },
  /*  检品比例一览汇 */
  {
    path: '/inspectRateList',
    name: 'inspectRateList',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/inspectRateList/index'),
    meta: {
      activeMenu: 'inspectRateList', // 可用选中菜单
    }
  },
  /*每日进度*/
  {
    path: '/dailyProgress',
    name: 'dailyProgress',
    component: () => import( /* webpackChunkName: "role" */ '@/views/home/auth/dailyProgress/index'),
    meta: {
      activeMenu: 'dailyProgress', // 可用选中菜单
    }
  },


]